import React from "react";
import "./underChartCustom.css";
import { Line } from "react-chartjs-2";
import Dropdown from "../Components/dropdown";

const UnderChartCustom = ({ title, dropdown }) => {
  let arr = [120, 117, 150, 178, 140, 111, 90, 105, 120, 130, 140, 150];
  let arr2 = arr.map((item) => item - 35);

  let options = {
    responsive: true,
    plugins: {
      //   tooltip: {
      //     enabled: true, // <-- this option disables tooltips
      //   },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 11,
          },
          display: true,
        },
        grid: {
          drawOnChartArea: false, // Extended vertical lines below x-axis only
        },
      },
      y: {
        display: true,
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        // beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
        },
        grid: {
          display: true, // Show horizontal grid lines
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  let state = {
    data: {
      // Add labels till 16
      labels: [
        "SEP",
        "OCT",
        "NOV",
        "DEC",
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
      ],
      datasets: [
        {
          label: "User Retention Rate",
          backgroundColor: (context) => {
            if (!context.chart.chartArea) return;
            const {
              ctx,
              chartArea: { top, bottom },
            } = context.chart;
            const gradientBackground = ctx.createLinearGradient(
              0,
              top,
              50,
              bottom
            );
            gradientBackground.addColorStop(0, "rgba(96, 184, 238, 0.2)");
            gradientBackground.addColorStop(0.5, "rgba(96, 184, 238, 0.1)");
            gradientBackground.addColorStop(0.9, "rgba(96, 184, 238, 0)");

            return gradientBackground;
          },
          borderColor: "#60B8EE",
          data: arr,
          fill: true,
          tension: 0.4,
          pointRadius: 3,
        },
        {
          label: "Feature Adoption Rate",
          backgroundColor: (context) => {
            if (!context.chart.chartArea) return;
            const {
              ctx,
              chartArea: { top, bottom },
            } = context.chart;
            const gradientBackground = ctx.createLinearGradient(
              0,
              top,
              20,
              bottom
            );
            gradientBackground.addColorStop(0, "rgba(61, 71, 121, 0.2)");
            gradientBackground.addColorStop(0.5, "rgba(61, 71, 121, 0.1)");
            gradientBackground.addColorStop(0.9, "rgba(61, 71, 121, 0)");

            return gradientBackground;
          },
          borderColor: "#3D4779",
          data: arr2,
          fill: true,
          tension: 0.4,
          pointRadius: 3,
        },
      ],
    },
  };

  return (
    <div className="pvxUnderChartCustom">
      <div className="title">
        <span>{title}</span>
        {dropdown && <Dropdown data={dropdown} />}
      </div>
      <div className="bottom">
          <Line
            height="260px"
            width="600px"
            options={options}
            data={state.data}
          />
      </div>
    </div>
  );
};

export default UnderChartCustom;
